import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import {  AppLinks} from "../../../constants/app-links";
import { getAvailablePolicyOptions } from "../../../store/actions/pets-actions";
import ModalDialog from "../../common/modal-dialog/ModalDialog";

import "./dont-cancel-yet-component.css";

class DontCancelYet extends Component {
  state = {
    lowestPremium: 0,
    changePremiumMessage: '',
    showKeepPolicyDialog: false,
  };

  componentDidMount() {
    this.props.actions.getAvailablePolicyOptions();
  }

  lowerPremiumBox = (accountOrPetID, petPolicies, petDetails) => {
    
    let lowestTotal = 0.0;

    if (accountOrPetID === 'cancelAccount') {
      
      // sum the lowest options for each pet
      for (let i=0; i < petPolicies.length; i++) {

        let lowestPremium = 99999999999999999999;
        for (let j=0; j < petPolicies[i].policies.length; j++) {
          if (petPolicies[i].policies[j].monthly_Subtotal <= lowestPremium) {
            lowestPremium = petPolicies[i].policies[j].monthly_Subtotal;
          }
        }

        lowestTotal = lowestTotal + lowestPremium;
      }

      return (
        <React.Fragment>
          <div className="change-premium-box col-12">
           <p>
              You can still lower your monthly premium as low as <strong>${lowestTotal.toFixed(2)}</strong>. 
              <br className="d-block d-sm-none"/>
              <button
                className="button-primary button-container change-premium-button ml-0 ml-md-4 mt-2 mt-md-0"
                onClick={() => {
                  this.props.history.push(AppLinks.policy.changePolicyOptions);
                }}
              >
                Change Premium
              </button>
            </p>
          </div>
          <p></p>
        </React.Fragment>
      );
    
    } else {

      let petName = '';
      let selectedPetDetail = {};

      // find the specified pet
      const selectedPetPolicy = petPolicies.find(policy => policy.pet.pet_id === accountOrPetID);
      selectedPetDetail = petDetails.find(petDetail => petDetail.PetID === selectedPetPolicy.pet.pet_id);

      let lowestPremium = 99999999999999999999;
      for (let i=0; i < selectedPetPolicy.policies.length; i++) {
        if (selectedPetPolicy.policies[i].monthly_Subtotal <= lowestPremium) {
          lowestPremium = selectedPetPolicy.policies[i].monthly_Subtotal;
        }
      }

      lowestTotal = lowestPremium;

      return (
        <React.Fragment>
          <div className="change-premium-box col-12">
            <p>
              You can still lower <strong>{selectedPetDetail.Name}</strong>'s monthly premium as low as <strong>${lowestTotal.toFixed(2)}</strong>. 
              <br className="d-block d-sm-none"/>
              <button
                className="button-primary button-container change-premium-button ml-0 ml-md-4 mt-2 mt-md-0"
                onClick={() => {
                  this.props.history.push(AppLinks.policy.changePolicyOptions);
                }}
              >
                Change Premium
              </button>
            </p>
          </div>
          <p></p>
        </React.Fragment>
      );
    }

  }

  toggleKeepPolicyDialog = () => {
    console.log('in toggleKeepPolicyDialog');

    this.setState({
      showKeepPolicyDialog: !this.state.showKeepPolicyDialog
    });
  };


  keepPolicyDialog = () => {

    let petName = "";
    if (this.props.accountOrPetID === 'cancelAccount') {
      petName = "your pet(s)";
    } else {
      const selectedPetDetail = this.props.petDetails.find(petDetail => petDetail.PetID === this.props.accountOrPetID);
      petName = selectedPetDetail.Name;
    }

    return (
      <ModalDialog
        isOpen={this.state.showKeepPolicyDialog}
        toggle={this.toggleKeepPolicyDialog}
        modalHeader={"Keep My Policy"}
        modalBody={
          <div className="d-flex flex-column">
            We are happy to hear that you'd like to keep your policy for {petName}. 
            We look forward to helping you and your pet(s) should any unexpected illness or accident occur.
          </div>
        }
        modalFooter={
          <button className="button-primary-plus close-button"
          onClick={() => {
            this.props.history.push("/");
          }}>
            Return to Home
          </button>
      }
        className="modal-popup"
      />
    );
  };  

  render() {
    const {
      fetchingAvailableOptions,
      error,
      availablePolicyOptions,
      availablePolicyOptionsError
    } = this.props;

    return (
      <React.Fragment>
        {this.keepPolicyDialog()}
        <div className="container dont-cancel-yet">
        { this.props.cancelReason === 'DO_NOT_SEE_VALUE' ? 
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <h1 className="title-container d-flex align-items-center">
                Don't Cancel Just Yet!
                </h1>
              </div>
            </div>
            <div className="row">
              
              <div className="col-12">
                <p className="mb-3">
                  <strong>
                    Reason: I don't see the value
                  </strong>
                </p>
                <p>
                  We're sorry to hear that you are considering canceling your policy with us. We want to remind you of the <strong>benefits of keeping your pet covered</strong> with a Healthy Paws plan:
                </p>
                <p>
                  <ul className="pl-3 mb-0">
                    <li>Helps <strong>cover the rising veterinary costs of care</strong> for unexpected injuries or illnesses</li>
                    <li><strong>Any claims covered by your Healthy Paws policy</strong> may be <strong>considered pre-existing by another provider</strong></li>
                    <li><strong>No maximum limits on payouts</strong>, which means no per incident, annual, or lifetime caps</li>
                  </ul>
                </p>
                <p>
                  If you would like to proceed with canceling your account, please select "continue to cancel" below. Please be aware that your account will not be canceled until you take this step. 
                </p>
              </div>
            </div>
            </React.Fragment> : null }
          { this.props.cancelReason === 'POLICY_DOES_NOT_WORK' ? 
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <h1 className="title-container d-flex align-items-center">
                Don't Cancel Just Yet!
                </h1>
              </div>
            </div>
            <div className="row">
              
              <div className="col-12">
                <p className="mb-3">
                  <strong>
                    Reason: The policy doesn't work for me
                  </strong>
                </p>
                <p>
                  We're sorry to hear that you are considering canceling your policy with us. While we may not be able to cover all medical expenses for your pet, we want to remind you of the <strong>benefits of keeping your pet covered</strong> with the Healthy Paws plan:
                </p>
                <p>
                  <ul className="pl-3 mb-0">
                    <li>Helps <strong>cover the rising veterinary costs of care</strong> for unexpected injuries or illnesses</li>
                    <li><strong>Any claims covered by your Healthy Paws policy</strong> may be <strong>considered pre-existing by another provider</strong></li>
                    <li><strong>No maximum limits on payouts</strong>, which means no per incident, annual, or lifetime caps</li>
                  </ul>
                </p>
                <p>
                  If you would like to proceed with canceling your account, please select "continue to cancel" below. Please be aware that your account will not be canceled until you take this step. 
                </p>
              </div>
            </div>
          </React.Fragment> : null }
          { this.props.cancelReason === 'BAD_CUSTOMER_EXPERIENCE' ? 
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <h1 className="title-container d-flex align-items-center">
                Don't Cancel Just Yet!
                </h1>
              </div>
            </div>
            <div className="row">
              
              <div className="col-12">
                <p className="mb-3">
                  <strong>
                    Reason: I had a bad customer service experience
                  </strong>
                </p>
                <p>
                  We're sorry to hear that you are considering canceling your policy with us and apologize that we did not meet
                  your expectations. We pride ourselves on providing world-class customer service to our pet parents, and always
                  appreciate <Link to={AppLinks.others.contact}>feedback</Link> to help us improve.
                </p>
                <p>
                  We want to remind you of the <strong>benefits of keeping your pet covered</strong> with a Healthy Paws plan:
                </p>
                <p>
                  <ul className="pl-3 mb-0">
                    <li>Helps <strong>cover the rising veterinary costs of care</strong> for unexpected injuries or illnesses</li>
                    <li><strong>No maximum limits on payouts</strong>, which means no per incident, annual, or lifetime caps</li>
                    <li>Healthy Paws is the <strong>top-rated pet insurance plan</strong> by several review sites</li>
                    <li><strong>Any claims covered by your Healthy Paws policy</strong> may be <strong>considered pre-existing by another provider</strong></li>
                  </ul>
                </p>
                <p>
                  If you would like to proceed with canceling your account, please select "continue to cancel" below. Please be aware that your account will not be canceled until you take this step. 
                </p>
              </div>
            </div>
            </React.Fragment> : null }
            { this.props.cancelReason === 'PREMIUM_TOO_HIGH' ? 
            <React.Fragment>
              <div className="row">
                <div className="col-12">
                  <h1 className="title-container d-flex align-items-center">
                  Don't Cancel Just Yet!
                  </h1>
                </div>
              </div>
              <div className="row">
                
                <div className="col-12">
                  <p className="mb-3">
                    <strong>
                      Reason: The premium is too high
                    </strong>
                  </p>
                  {this.props.petDetails &&
                    this.props.petDetails.length > 0 &&
                    !error &&
                    !availablePolicyOptionsError &&
                    availablePolicyOptions ? (
                      this.lowerPremiumBox(this.props.accountOrPetID, this.props.availablePolicyOptions.available_policies, this.props.petDetails)
                    ) : null
                  }
                  <p>
                    We're sorry to hear that you are considering canceling your policy with us.
                  </p>
                  <p>
                    We understand that monthly premiums can be difficult to manage and we would be happy to explore your options with
                    you to reduce your monthly premiums. If this is something you would like to explore, please visit our <Link to={AppLinks.policy.changePolicyOptions}>change policy options page</Link>.
                  </p>
                  <p>
                    We strive to keep premiums as low as possible. As we continue to pay out claim reimburements to pet parents, we
                    must keep premiums at a rate that reflects the cost of covering claims. Premium rates have been filed and approved
                    by your state, where required, which means we are unable to make any changes to the premium rates for your pet.
                  </p>
                  <p>
                    We want to remind you of the <strong>benefits of keeping your pet covered</strong> with a Healthy Paws plan:
                  </p>
                  <p>
                    <ul className="pl-3 mb-0">
                      <li>Helps <strong>cover the rising veterinary costs of care</strong> for unexpected injuries or illnesses</li>
                      <li><strong>No maximum limits on payouts</strong>, which means no per incident, annual, or lifetime caps</li>
                      <li>Healthy Paws is the <strong>top-rated pet insurance plan</strong> by several review sites</li>
                      <li><strong>Any claims covered by your Healthy Paws policy</strong> may be <strong>considered pre-existing by another provider</strong></li>
                    </ul>
                  </p>
                  <p>
                    If you would like to proceed with canceling your account, please select "continue to cancel" below. Please be aware that your account will not be canceled until you take this step. 
                  </p>
                </div>
              </div>
            </React.Fragment> : null }            
          <div className="d-flex flex-column flex-md-row mt-2 mt-lg-3 mb-4">

            <button className="button-primary-plus button-container" onClick={this.props.continueToCancel}>
              Continue to Cancel
            </button>

              <button onClick={this.toggleKeepPolicyDialog} className="button-secondary button-keep button-container ml-0 ml-md-4 mt-2 mt-md-0">
                No, Keep My Policy
              </button>

          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  availablePolicyOptions: state.pets.availablePolicyOptions,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
      { getAvailablePolicyOptions },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DontCancelYet);
